// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { DeviceGroupControlContent, unionToDeviceGroupControlContent, unionListToDeviceGroupControlContent } from './device-group-control-content';
import { ElevatorGroupControlMessage, ElevatorGroupControlMessageT } from './elevator-group-control-message';
import { EscalatorGroupControlMessage, EscalatorGroupControlMessageT } from './escalator-group-control-message';


export class GroupControlMessage implements flatbuffers.IUnpackableObject<GroupControlMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):GroupControlMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsGroupControlMessage(bb:flatbuffers.ByteBuffer, obj?:GroupControlMessage):GroupControlMessage {
  return (obj || new GroupControlMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsGroupControlMessage(bb:flatbuffers.ByteBuffer, obj?:GroupControlMessage):GroupControlMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new GroupControlMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

messageType():DeviceGroupControlContent {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : DeviceGroupControlContent.NONE;
}

message<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startGroupControlMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addMessageType(builder:flatbuffers.Builder, messageType:DeviceGroupControlContent) {
  builder.addFieldInt8(0, messageType, DeviceGroupControlContent.NONE);
}

static addMessage(builder:flatbuffers.Builder, messageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, messageOffset, 0);
}

static endGroupControlMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // message
  return offset;
}

static createGroupControlMessage(builder:flatbuffers.Builder, messageType:DeviceGroupControlContent, messageOffset:flatbuffers.Offset):flatbuffers.Offset {
  GroupControlMessage.startGroupControlMessage(builder);
  GroupControlMessage.addMessageType(builder, messageType);
  GroupControlMessage.addMessage(builder, messageOffset);
  return GroupControlMessage.endGroupControlMessage(builder);
}

unpack(): GroupControlMessageT {
  return new GroupControlMessageT(
    this.messageType(),
    (() => {
      const temp = unionToDeviceGroupControlContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: GroupControlMessageT): void {
  _o.messageType = this.messageType();
  _o.message = (() => {
      const temp = unionToDeviceGroupControlContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}
}

export class GroupControlMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public messageType: DeviceGroupControlContent = DeviceGroupControlContent.NONE,
  public message: ElevatorGroupControlMessageT|EscalatorGroupControlMessageT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const message = builder.createObjectOffset(this.message);

  return GroupControlMessage.createGroupControlMessage(builder,
    this.messageType,
    message
  );
}
}
